<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.saveLocation}}</h3>
</div>
<div class="modal-body">
    <form #kvForm="ngForm" name="kvForm" class="form-signin" style="max-width:400px">
        <div class="row">
            <div class="col-md-12" >
                <label for="name" class="">{{LOCALIZATION.name}}</label>
                <input type="text" 
                	[(ngModel)]='name'
                	id="name" name="name" 
                	class="form-control" required autofocus>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!kvForm.valid">{{LOCALIZATION.save}}</button>
</div>